// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"d09562a2","160":"eb1e6e1a","190":"59f23c59","223":"9def8b3d","441":"1300b14b","453":"89222f80","468":"337a2b95","475":"20a38420","663":"bdc4a7ce","779":"542220fb"}[chunkId] + ".chunk.js";
};